import qs from 'qs'

type ExtraValue = string | number | string[] | number[] | undefined

export const mergeQueryString = (queryString: string, extra: Record<string, ExtraValue>) => {
  const merged = {
    ...qs.parse(queryString, { ignoreQueryPrefix: true }),
    ...extra,
  }
  return qs.stringify(merged, {
    addQueryPrefix: true,
    skipNulls: true,
    arrayFormat: 'comma',
  })
}
